export enum ReportStateType {
  Waiting = 'pending_first',
  Return = 'pending_second',
  Finished = 'finished'
}
